(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WeaveScheduler", [], factory);
	else if(typeof exports === 'object')
		exports["WeaveScheduler"] = factory();
	else
		root["WeaveScheduler"] = factory();
})(this, function() {
return 